import axios from 'axios';

// Usando valores fixos como fallback caso as variáveis de ambiente não estejam disponíveis
const ExossCardApiVersion = process.env.REACT_APP_WALLET_API_VERSION || 'v1';
const ExossCardApiUrl = (process.env.REACT_APP_WALLET_URL || 'http://localhost:8000') + '/api/';

// Configurar interceptor global
axios.interceptors.response.use(
    response => response,
    error => {
        if (error.response && error.response.status === 401) {
            sessionStorage.removeItem('userData');
            window.location.href = '/';
            return Promise.reject(error);
        }
        return Promise.reject(error);
    }
);

export default class ApiService {
    static ExossCardApiUrl() { return ExossCardApiUrl; }
    static ExossCardApiVersion() { return ExossCardApiVersion; }

    static getHeaders(token) {
        return {
            'Authorization': token ? 'Bearer ' + token : '',
            'Content-Type': 'application/json'
        }
    }

    static get(url, token) {
        const options = {
            url: `${ExossCardApiUrl}${url}`,
            method: 'GET',
            headers: this.getHeaders(token)
        };
        return axios(options);
    }

    static post(url, dados, token, config = {}) {
        // Verificar se config é uma string (método antigo) ou um objeto de configuração
        const method = typeof config === 'string' ? config : 'POST';
        
        // Mesclar os cabeçalhos padrão com os cabeçalhos personalizados
        let headers = this.getHeaders(token);

        console.log('headers', headers);
        
        // Se tivermos configurações extras e contiver cabeçalhos, mesclar com os padrões
        if (typeof config === 'object' && config.headers) {
            headers = { ...headers, ...config.headers };
        }
        
        const options = {
            url: `${ExossCardApiUrl}${url}`,
            method: method,
            headers: headers,
            data: dados,
            // Incluir outras propriedades de config, se fornecidas
            ...(typeof config === 'object' && config)
        };
        
        return axios(options);
    }

    static put(url, dados, token, method) {
        const options = {
            url: `${ExossCardApiUrl}${url}`,
            method: method ? method : 'PUT',
            headers: this.getHeaders(token),
            data: dados
        };
        return axios(options);
    }

    static getGeral(url, token) {
        return this.get(`geral/${url}`, token);
    }

    static postGeral(url, dados, token, method) {
        return this.post(`geral/${url}`, dados, token, method);
    }

    static getEmpresa(url, token) {
        return this.get(`empresa/${url}`, token);
    }

    static postEmpresa(url, dados, token, method) {
        return this.post(`empresa/${url}`, dados, token, method);
    }

    static customRequest(url, dados, metodo, token) {
        const options = {
            url: `${ExossCardApiUrl}${url}`,
            method: metodo,
            headers: this.getHeaders(token),
            data: dados ? dados : {}
        }
        return axios(options);
    }

    static handleErros(response) {
        if (response && response.status === 401) {
            sessionStorage.removeItem('userData');
            window.location.href = '/';
        }

        console.log(response);
        
        if (response && response.data && (response.data.message || response.data.mensagem) ) {
            return { response: response.data.message || response.data.mensagem };
        }
        return { response: 'Ocorreu um erro inesperado.' };
    }
}
